import Footer from "../Footer";
import Cookies from 'js-cookie';
import Landingheader from "./Landingheader";
import { useEffect, useState } from "react";
import socket from 'socket.io-client';
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

// Contact.jsx
const io = socket.connect('https://land-survey-main-server.onrender.com');

const Contact = () => {
const Navigate = useNavigate();
const client_token = Cookies.get('user_token');
const admin_token = Cookies.get('Admin_token');
const [name, setName] = useState('');
const [email, setEmail] = useState('');
const [message, setMessage] = useState('');

// --- NEW FEATURE CODE START ---
const [adminFeedback, setAdminFeedback] = useState([]);

useEffect(() => {

  
  
io.on('problem',(msg) => {
  alert(msg);
})

io.on('admin_feedback_to_client', (data) => {
  setAdminFeedback((prev) => [
    ...prev, {
      feedBack: data,
      time: new Date()
    }
  ]);
});

return () => {io.off('admin_feedback_to_client'); io.off('problem')};
}, []);
// --- NEW FEATURE CODE END ---

useEffect(() => {
if (client_token) {
io.emit('verify', client_token);
}
}, []);

const Sendmessage = () => {
if (client_token) {
const decoded = jwtDecode(client_token);
if (decoded.name === name && decoded.email === email && message !== '') {
io.emit('send_message_to_admin_from_client', {
name: decoded.name, 
email: decoded.email,
message,
senderId: decoded.id
});
} else {
console.log('provide your valid name and email');
}
} else {
Navigate('/login');
}
}

return (
<div>
<Landingheader />
<div className="px-8 py-16 bg-gray-50">
<h2 className="text-3xl font-bold text-center text-gray-800">
Contact Us
</h2>

<p className="mt-4 text-center text-gray-600">
Have questions about our land surveying services? We’d love to hear from you.
</p>

<div className="grid max-w-5xl grid-cols-1 gap-10 mx-auto mt-10 md:grid-cols-2">
{/* Contact Form */}
<form className="p-8 space-y-6 bg-white rounded-lg shadow-lg" onSubmit={(e) => {
e.preventDefault();
Sendmessage();
}}>
<div>
<label className="block text-sm font-medium text-gray-700">Name</label>
<input
type="text"
placeholder="Your Name"
className="w-full px-4 py-2 mt-2 border rounded-lg focus:ring focus:ring-blue-300"
onChange={(e) => {
setName(e.target.value);
}}
required
/>
</div>

<div>
<label className="block text-sm font-medium text-gray-700">Email</label>
<input
type="email"
placeholder="you@example.com"
className="w-full px-4 py-2 mt-2 border rounded-lg focus:ring focus:ring-blue-300"
onChange={(e) => {
setEmail(e.target.value);
}}
required
/>
</div>

<div>
<label className="block text-sm font-medium text-gray-700">Message</label>
<textarea
rows="4"
placeholder="Write your message..."
className="w-full px-4 py-2 mt-2 border rounded-lg focus:ring focus:ring-blue-300"
onChange={(e) => {
setMessage(e.target.value);
}}
required
></textarea>
</div>

<button
type="submit"
className="w-full py-3 font-semibold text-white transition bg-blue-600 rounded-lg hover:bg-blue-700"
>
Send Message
</button>
</form>

{/* Contact Info & Admin Feedback */}
<div className="space-y-6">
<div className="p-8 space-y-6 bg-white rounded-lg shadow-lg">
<h3 className="text-xl font-bold text-gray-800">Get in Touch</h3>
<div className="space-y-4">
<p><span className="font-semibold">📍 Address:</span> Kigali, Rwanda</p>
<p><span className="font-semibold">📞 Phone:</span> +250 123 456 789</p>
<p><span className="font-semibold">✉️ Email:</span> info@surveyco.com</p>
</div>
</div>

{/* --- NEW FEEDBACK UI SECTION --- */}
<div className="p-8 bg-white border-t-4 border-blue-500 rounded-lg shadow-lg">
<h3 className="mb-4 text-xl font-bold text-gray-800">Admin Feedback</h3>
{adminFeedback.length === 0 ? (
<p className="text-sm italic text-gray-500">No feedback received yet.</p>
) : (
<div className="space-y-4 overflow-y-auto max-h-60">
{adminFeedback.map((fb, index) => (
<div key={index} className="p-3 border border-blue-100 rounded-md bg-blue-50">
<p className="text-sm text-gray-800">{fb.feedBack}</p>
<span className="text-[10px] text-gray-400 mt-1 block">
{new Date().toLocaleTimeString()}
</span>
</div>
))}
</div>
)}
</div>
</div>
</div>
</div>
<Footer />
</div>
);
};

export default Contact;